export default "__VITE_ASSET__CK43R_5l__"